import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { MenuItem } from 'primeng/api';
import { Menu } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-card-user',
  imports: [
    CommonModule,
    TagModule,
    Menu,
    ButtonModule
  ],
  templateUrl: './card-user.component.html',
  styleUrl: './card-user.component.scss'
})
export class CardUserComponent implements OnInit {
  @Input() dados!: any[];
  @Input() codigo!: any;
  @Input() nome!: string;
  @Input() email!: string;
  @Input() telefone!: string;
  @Input() registo!: string;
  @Input() estado!: boolean;
  openedMenu: Menu | null = null;
  @Input() actions: ((rowData: any) => MenuItem[]) | MenuItem[] = [];
  @Output() rowClick = new EventEmitter<any>();
  @Input() user!: any;
  @Input() activeMenu!: Menu | null;
  @Output() menuOpened = new EventEmitter<Menu>();
  @Output() menuClosed = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }

  getSeverity(state: boolean) {
    switch (state) {
      case true:
        return 'success';
      case false:
        return 'danger';
      default:
        return 'secondary';
    }
  }

  getMenuActions(): MenuItem[] {
    if (typeof this.actions === 'function') {
      return this.actions(this.user);
    }

    return this.actions.map((action) => ({
      ...action,
      command: (event: any) => action.command?.({ ...event, item: this.user })
    }));
  }

  updateMenuActions() {
    if (this.dados) {
      this.dados = this.dados.map((rowData: any) => ({
        ...rowData,
        menuActions: this.getMenuActions(),
      }));
    }
  }

  openMenu(event: MouseEvent, menu: Menu) {
    event.preventDefault();
    event.stopPropagation();

    this.menuOpened.emit(menu);
    menu.show(event);
  }

  onRowClick(rowData: any) {
    this.rowClick.emit(rowData);
  }
}
